import { observer } from "mobx-react";
import { IRMAEmailLog } from "../../../rma-types";
import { ConfirmModal } from "../../../../../../components/modal/components/confirm-modal/confirm-modal";
import RmaPageStore from "../../../stores/rma-page-store";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IProps {
    rma: RmaPageStore;
    emailLog: IRMAEmailLog;
    onCloseClick: () => void;
}

const ResendStatusModal: React.FC<IProps> = observer(({ rma, emailLog, onCloseClick }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-returns-rma-card';
    const rmaCardPopups = 'dashboard-rma-card-popups';
    const onButtonClicked = async () => {
        await rma.resendStatusEmail(emailLog.id);
        onCloseClick();
    }
    return (
        <ConfirmModal
            title={getTranslation('RESEND_STATUS_EMAIL_OPTION', scope)}
            text={<>{getTranslation('YOU_ASKED_TO_RESEND', rmaCardPopups)} <strong>{emailLog.translation_key ? getTranslation(emailLog.translation_key, scope) : emailLog.label}</strong> {getTranslation('EMAIL', rmaCardPopups)}. {getTranslation('SEND_ORIGINAL_EMAIL', rmaCardPopups)}</>}
            questionText={<>{getTranslation('ARE_YOU_SURE', rmaCardPopups)} <strong>{emailLog.translation_key ? getTranslation(emailLog.translation_key, scope) : emailLog.label}</strong> {getTranslation('EMAIL', rmaCardPopups)}?</>}
            cancelButton={{
                title: getTranslation('CANCEL', rmaCardPopups),
                onClick: () => onCloseClick()
            }} okButton={{
                title: getTranslation('RESEND', rmaCardPopups),
                onClick: onButtonClicked,
                hasLoader: true,
                isLoading: rma.isResendingStatusEmail,
            }}
        />
    );
});

export default ResendStatusModal;